// ========== 装备数据 ==========
export const TIERS = {
  common:  { name:'普通', color:'#aaa', cssClass:'tier-common' },
  fine:    { name:'精良', color:'#5a8', cssClass:'tier-fine' },
  rare:    { name:'稀有', color:'#5af', cssClass:'tier-rare' },
  unique:  { name:'罕见', color:'#b0f', cssClass:'tier-unique' },
  epic:    { name:'史诗', color:'#f80', cssClass:'tier-epic' },
};
export const EQUIPMENT_DB = [
  // === 普通装备 (Lv.1-10) ===
  { id:'rusty_sword',     name:'生锈的铁剑',   tier:'common',  slot:'weapon',   weaponType:'blade', lv:1,  atk:3, desc:'每一把传说之剑，都曾是一块生锈的铁。 — 林纳斯' },
  { id:'worn_leather',    name:'破旧的皮甲',   tier:'common',  slot:'armor',    lv:1,  def:2, desc:'虽然破了，但比没有好。 — 赛丽亚' },
  { id:'goblin_boots',    name:'哥布林短靴',   tier:'common',  slot:'boots',    lv:1,  def:1, spd:1, desc:'从哥布林脚上扒下来的。 — 冒险家公会' },
  { id:'crude_shield',    name:'粗制木盾',     tier:'common',  slot:'weapon',   weaponType:'blade', lv:2,  atk:1, def:2, desc:'新手铁匠的练手之作。 — 铁匠学徒' },
  { id:'hemp_belt',       name:'麻布腰带',     tier:'common',  slot:'belt',     lv:1,  def:1, desc:'一根普通的麻绳腰带。 — 杂货铺老板' },
  { id:'cotton_pants',    name:'棉布长裤',     tier:'common',  slot:'pants',    lv:1,  def:2, desc:'粗棉布做的裤子，还算结实。 — 裁缝玛莎' },
  // === 精良装备 (Lv.5-15) ===
  { id:'fine_steel_sword',name:'精铁长剑',     tier:'fine',    slot:'weapon',   weaponType:'blade', lv:5,  atk:7, str:1, desc:'好铁才能打出好剑。 — 林纳斯' },
  { id:'bull_leather',    name:'牛头兽皮甲',   tier:'fine',    slot:'armor',    lv:8,  def:6, str:2, desc:'用牛头兽的毛皮鞣制，坚韧异常。 — 猎人公会' },
  { id:'goblin_chief_belt',name:'哥布林头目腰带',tier:'fine',   slot:'belt',     lv:5,  def:3, atk:2, desc:'哥布林头目珍藏的腰带，有一股奇怪的味道。 — 冒险家笔记' },
  { id:'light_boots',     name:'轻羽战靴',     tier:'fine',    slot:'boots',    lv:10, def:3, spd:4, desc:'轻如羽毛，快如疾风。 — 风之谷长老' },
  { id:'bone_helm',       name:'亡灵骨盔',     tier:'fine',    slot:'helm',     lv:8,  def:5, str:1, desc:'以亡灵之力铸就的头盔。 — 暗黑精灵' },
  { id:'fine_leather_pants',name:'精制皮裤',   tier:'fine',    slot:'pants',    lv:6,  def:4, spd:2, desc:'比普通皮裤更耐穿。 — 防具商人' },
  // === 稀有装备 (Lv.10-25) ===
  { id:'thunder_blade',   name:'雷鸣太刀',     tier:'rare',    slot:'weapon',   weaponType:'blade', lv:12, atk:12, str:3, spd:2, desc:'雷声响起，刀刃已至。 — 西岚' },
  { id:'flame_chest',     name:'烈焰胸甲',     tier:'rare',    slot:'armor',    lv:15, def:10, str:4, desc:'彼诺修的火炎凝结而成的铠甲。 — 魔法师工会' },
  { id:'ice_amulet',      name:'冰晶项链',     tier:'rare',    slot:'amulet',   lv:14, def:4, int:6, desc:'永不融化的冰之结晶。 — 冰之女王' },
  { id:'lightning_brace', name:'落雷手镯',     tier:'rare',    slot:'bracelet', lv:13, def:3, atk:5, desc:'凯诺的闪电之力封于其中。 — 炼金术师' },
  { id:'dark_ring',       name:'暗黑戒指',     tier:'rare',    slot:'ring',     lv:11, atk:4, def:3, desc:'黑暗的力量在你指尖流转。 — 夏洛克' },
  { id:'dragon_pants',    name:'龙骨长裤',     tier:'rare',    slot:'pants',    lv:16, def:8, str:3, desc:'以龙骨碎片编织，坚不可摧。 — 龙族后裔' },
  // === 罕见装备 (Lv.20-35) ===
  { id:'light_judgment',  name:'光之裁决',     tier:'unique',  slot:'weapon',   weaponType:'holy', lv:22, atk:18, str:6, spd:3,
    desc:'圣光与你同在，裁决罪恶。 — 欧贝斯',
    quote:'真正的光明不是没有黑暗，而是在黑暗中依然选择前行。 — 欧贝斯',
    onAttack:'圣光', atkEffect:'holyLight' },
  { id:'dragon_scale_armor',name:'龙鳞铠甲',  tier:'unique',  slot:'armor',    lv:25, def:16, str:6, int:2,
    desc:'天龙的一片鳞片所化，坚不可摧。 — 龙族长老',
    quote:'这片鳞甲上，还残存着千年前那场战役的灼痕。 — 龙族铭文',
    onAttack:'龙鳞' },
  { id:'angel_helm',      name:'天使银翼头盔', tier:'unique',  slot:'helm',     lv:20, def:10, spd:5, atk:3,
    desc:'堕落前的最后荣光。 — 堕天使之叹',
    quote:'我见过天堂的模样，也已被它永远放逐。 — 堕天使',
    onAttack:'银翼' },
  { id:'sky_crown',       name:'天空王冠',     tier:'unique',  slot:'helm',     lv:28, def:12, str:4, int:4,
    desc:'天空之王的遗物，王者气质尽显。 — 魔法皇帝',
    quote:'王权没有永恒，但荣耀不朽。 — 天空之王',
    onAttack:'君临' },
  { id:'guard_brace',     name:'守护者圣镯',   tier:'unique',  slot:'bracelet', lv:24, def:8, int:6,
    desc:'神圣之力护佑你免于黑暗侵蚀。 — 圣者之愿',
    quote:'我在黑暗中等待了千年，只为找到你这样的勇者。 — 守护者',
    onAttack:'守护' },
  { id:'wind_ring',       name:'疾风之戒',     tier:'unique',  slot:'ring',     lv:22, atk:7, spd:8,
    desc:'戴上它，风都会为你让路。 — 风行者',
    quote:'让风带着你奔跑吧，少年。前面的路还很长。 — 风行者',
    onAttack:'追风' },
  // === 史诗装备 (Lv.30+) ===
  { id:'chaos_blade_v2',  name:'混沌之刃',     tier:'epic',    slot:'weapon',   weaponType:'blade', lv:30, atk:25, str:8, spd:5,
    desc:'秩序与混沌的交汇点，一刀斩开命运。 — 索德罗斯',
    quote:'万物始于混沌，也终归于混沌。握住它，你就是新秩序的缔造者。 — 索德罗斯',
    onAttack:'混沌', atkEffect:'chaosBlade' },
  { id:'arad_battle_armor',name:'阿拉德战铠',  tier:'epic',    slot:'armor',    lv:32, def:22, str:8, int:4,
    desc:'阿拉德大陆的守护之力集结于此。 — 帝国大元帅',
    quote:'这副铠甲里，熔铸了所有为阿拉德献出生命的英魂。请替他们活下去。 — 帝国大元帅',
    onAttack:'阿拉德' },
  { id:'dark_holy_grail', name:'暗黑圣杯',     tier:'epic',    slot:'weapon',   weaponType:'holy', lv:35, atk:22, int:10,
    desc:'黑色的圣杯中涌动着不洁之力。 — 绝望之塔',
    quote:'喝下杯中物，你将获得力量，也将永远失去安眠。 — 绝望之塔铭文',
    onAttack:'暗影', atkEffect:'darkGrail' },
  { id:'eternal_flame',   name:'不灭之炎项链', tier:'epic',    slot:'amulet',   lv:33, def:10, atk:6, int:6,
    desc:'永恒的火焰，永远不会熄灭。 — 火焰之神',
    quote:'在阿拉德创世之初就燃起的火焰，如今被系在你的颈间。 — 火焰之神',
    onAttack:'炎魂' },
  { id:'doom_ring',       name:'末日指环',     tier:'epic',    slot:'ring',     lv:34, atk:10, def:6, int:6,
    desc:'预言中的终焉，封印于一枚小小的戒指。 — 先知之言',
    quote:'末日也许会来，但在那之前...戴上它，你就是阻止末日的人。 — 先知',
    onAttack:'末日' },
  { id:'truth_light',     name:'真理之光',     tier:'epic',    slot:'weapon',   weaponType:'holy', lv:38, atk:30, str:5, int:5,
    desc:'当真理之光照耀，一切虚假都将瓦解。 — G·S·D',
    quote:'瞎子不代表看不清真相。有时闭上眼，才能看到光。 — G·S·D',
    onAttack:'真理', atkEffect:'truthLight' },
  // === 新增装备 (v5.2) ===
  { id:'steel_gauntlet',  name:'钢铁拳套',     tier:'fine',    slot:'weapon',   weaponType:'fist', lv:10, atk:8, spd:2, desc:'铁匠铺的新作，适合格斗家。 — 林纳斯' },
  { id:'long_barrel',     name:'长管步枪',     tier:'fine',    slot:'weapon',   weaponType:'gun',  lv:12, atk:9, spd:2, desc:'精准的长管步枪，射击手感一流。 — 神枪手公会' },
  { id:'shadow_boots',    name:'暗影之靴',     tier:'rare',    slot:'boots',    lv:14, def:5, spd:6, desc:'踏影而行，无声无息。 — 暗精灵刺客' },
  { id:'phoenix_ring',    name:'凤凰指环',     tier:'rare',    slot:'ring',     lv:15, atk:6, int:4, desc:'封印着不死鸟的一丝余烬。 — 古代遗物' },
  { id:'iron_will_belt',  name:'钢铁意志腰带', tier:'rare',    slot:'belt',     lv:13, def:6, str:3, desc:'系上它，意志如钢铁。 — 帝国军官' },
  { id:'moonlight_blade', name:'月光之刃',     tier:'unique',  slot:'weapon',   weaponType:'blade', lv:26, atk:20, spd:6,
    desc:'月光凝成的刀刃，寒光逼人。 — 月之精灵',
    quote:'每一个满月之夜，这把刀都会轻声低吟。 — 月之精灵',
    onAttack:'月华' },
  { id:'thunder_helm',    name:'雷鸣战盔',     tier:'unique',  slot:'helm',     lv:24, def:11, str:5, atk:4,
    desc:'雷声在盔中回荡，震慑一切敌人。 — 凯诺的遗产',
    quote:'戴上它，你就能听到雷声的低语。 — 雷霆哥布林祭司',
    onAttack:'雷鸣' },
  { id:'abyss_cloak',     name:'深渊斗篷',     tier:'unique',  slot:'armor',    lv:27, def:14, int:8, spd:3,
    desc:'深渊之力编织的斗篷，吞噬一切光芒。 — 暗精灵女王',
    quote:'来自深渊的衣服，穿它的人会梦见自己坠入无底的黑暗。 — 不知名冒险家',
    onAttack:'深渊' },
  { id:'ragnarok',        name:'诸神黄昏',     tier:'epic',    slot:'weapon',   weaponType:'blade', lv:40, atk:35, str:10, spd:8,
    desc:'传说中终结神灵之战的魔剑。 — 上古传说',
    quote:'诸神的时代已经终结。这把剑就是证明。 — 无名墓碑铭文',
    onAttack:'神灭', atkEffect:'chaosBlade' },
  { id:'seraph_wing',     name:'炽天使之翼',   tier:'epic',    slot:'amulet',   lv:36, def:12, int:12, spd:4,
    desc:'六翼炽天使的羽翼所化的项链。 — 天界圣物',
    quote:'戴上它，你能感受到天使羽翼的温暖…还有重量。 — 圣者米歇尔',
    onAttack:'圣翼' },
  { id:'void_walker',     name:'虚空行者之靴', tier:'epic',    slot:'boots',    lv:38, def:14, spd:12, int:4,
    desc:'跨越虚空的魔法之靴。 — 次元行者',
    quote:'每一步都踩在两个世界的边缘。 — 次元行者笔记',
    onAttack:'虚空' },
  { id:'atom_cannon',     name:'原子炮',       tier:'epic',    slot:'weapon',   weaponType:'gun',  lv:42, atk:38, str:8,
    desc:'天界科技的巅峰之作，微型核聚变炮。 — 七神之鞘翅',
    quote:'按下扳机的瞬间，太阳在你的手中诞生。 — 机械七战神',
    onAttack:'聚变', atkEffect:'truthLight' },
  // === v5.3 新增装备 ===
  // 精良
  { id:'sharp_dagger',    name:'锋利匕首',     tier:'fine',    slot:'weapon',   weaponType:'blade', lv:7,  atk:6, spd:3, desc:'磨得发亮的匕首，适合快速出击。 — 盗贼公会' },
  { id:'chainmail',       name:'连环锁甲',     tier:'fine',    slot:'armor',    lv:9,  def:7, str:1, desc:'铁环相扣，轻便又坚固。 — 防具大师' },
  { id:'traveler_ring',   name:'旅者之戒',     tier:'fine',    slot:'ring',     lv:6,  atk:2, spd:3, def:1, desc:'行走江湖的冒险家最爱。 — 杂货铺' },
  // 稀有
  { id:'serpent_bow',     name:'蝮蛇长弓',     tier:'rare',    slot:'weapon',   weaponType:'gun',  lv:13, atk:11, spd:5, desc:'弓弦如毒蛇吐信。 — 精灵猎手' },
  { id:'giant_belt',      name:'巨力腰带',     tier:'rare',    slot:'belt',     lv:16, def:7, str:4, desc:'带上之后力大无穷！ — 竞技场冠军' },
  { id:'sorcerer_hat',    name:'术士帽',       tier:'rare',    slot:'helm',     lv:14, def:5, int:7, desc:'帽子里藏着古老的魔法。 — 魔法学院' },
  { id:'stone_bracelet',  name:'磐石手镯',     tier:'rare',    slot:'bracelet', lv:15, def:8, str:3, desc:'感觉戴上后手臂像是覆了一层岩石。 — 地精工匠' },
  // 罕见
  { id:'blood_reaver',    name:'饮血者',       tier:'unique',  slot:'weapon',   weaponType:'blade', lv:28, atk:22, str:7,
    desc:'每砍一刀，剑刃都在渴求更多的鲜血。 — 血之伯爵',
    quote:'这不是武器，是活着的诅咒。 — 阿拉德纪年',
    onAttack:'嗜血', atkEffect:'lifeSteal' },
  { id:'storm_bracers',   name:'暴风护腕',     tier:'unique',  slot:'bracelet', lv:26, def:9, spd:10, atk:3,
    desc:'风之力在你腕间流转。 — 风行者之赐',
    quote:'当风暴来临时，你不是躲避它，而是成为它。 — 风暴之女',
    onAttack:'风暴' },
  { id:'shadow_reaper',   name:'暗影收割者',   tier:'unique',  slot:'weapon',   weaponType:'fist', lv:29, atk:24, spd:7,
    desc:'从影子中诞生的武器，专收亡魂。 — 死神之刃',
    quote:'每一道暗影，都曾是一束光。 — 不知名碑文',
    onAttack:'收割', atkEffect:'shadowStrike' },
  // 史诗 (带战斗被动)
  { id:'blade_storm',     name:'刃风暴',       tier:'epic',    slot:'weapon',   weaponType:'blade', lv:45, atk:40, str:12, spd:10,
    desc:'每次挥砍都会释放一道剑气追击敌人。 — 剑神之遗',
    quote:'一千次挥砍，一千道剑气。这是用时间铸就的奥义。 — 索德罗斯',
    onAttack:'剑气', atkEffect:'flyingBlade' },
  { id:'thunder_lord',    name:'雷主之握',     tier:'epic',    slot:'weapon',   weaponType:'fist', lv:44, atk:38, str:10, spd:8,
    desc:'拳劲携雷，击中后闪电链波及所有敌人。 — 雷霆主宰',
    quote:'你的每一次挥拳，都会在敌人心中留下一道雷电。 — 哥布林祭司',
    onAttack:'连锁', atkEffect:'chainLightning' },
  { id:'frozen_heart',    name:'冰封之心',     tier:'epic',    slot:'amulet',   lv:40, def:14, int:14,
    desc:'攻击有概率冻结敌人，冰霜之力永伴。 — 冰之女王遗产',
    quote:'心跳即是寒冰的节奏。 — 冰封千年者',
    onAttack:'冰封', atkEffect:'frostTouch' },
  { id:'vampire_fang',    name:'血族獠牙',     tier:'epic',    slot:'ring',     lv:41, atk:12, def:8,
    desc:'吸取敌人生命之力，永动机般的续航。 — 血族圣物',
    quote:'生命不是用来消耗的，是用来交换的。 — 血族长老',
    onAttack:'吸血', atkEffect:'vampirism' },
  { id:'inferno_boots',   name:'炼狱行者',     tier:'epic',    slot:'boots',    lv:43, def:16, spd:14,
    desc:'每一步都在地面留下火焰之路。 — 地狱使者',
    quote:'这双靴子走过的路，寸草不生。 — 冒险家公会',
    onAttack:'焚尽', atkEffect:'infernalSteps' },
];
export const CONSUMABLES = {
  hp_potion_s:  { name:'初级HP药剂', desc:'恢复40点生命',   heal:40,  price:5,  color:'#4a8' },
  hp_potion_m:  { name:'中级HP药剂', desc:'恢复100点生命',  heal:100, price:15, color:'#5b8' },
  hp_potion_l:  { name:'高级HP药剂', desc:'恢复250点生命',  heal:250, price:40, color:'#6c8' },
  mp_potion_s:  { name:'技能药剂',   desc:'恢复30点技能值', mpHeal:30, price:8,  color:'#56a' },
  antidote:     { name:'解毒药',     desc:'治疗中毒状态',   cure:'poison', price:12, color:'#8a2' },
};

export const ITEM_ICONS = {
  // 装备槽图标
  weapon:   '⚔️', helm: '🪖', amulet: '📿', bracelet: '⭕',
  armor:    '🛡️', ring: '💍', belt: '🔗', pants: '👖', boots: '👢',
  // 消耗品
  hp_potion_s: '🧪', hp_potion_m: '🧪', hp_potion_l: '🧪',
  mp_potion_s: '💠', antidote: '🌿',
  // 物品通用
  item: '📦',
};

export function getEquipById(id) {
  return EQUIPMENT_DB.find(e => e.id === id) || null;
}

// 强化表
export const ENHANCE_TABLE = [
  { lv:1,  cost:200,  rate:1.0,  penalty:0 },
  { lv:2,  cost:400,  rate:1.0,  penalty:0 },
  { lv:3,  cost:600,  rate:1.0,  penalty:0 },
  { lv:4,  cost:1000, rate:0.8,  penalty:0 },
  { lv:5,  cost:1500, rate:0.8,  penalty:0 },
  { lv:6,  cost:2000, rate:0.8,  penalty:0 },
  { lv:7,  cost:3000, rate:0.6,  penalty:-1 },
  { lv:8,  cost:4500, rate:0.6,  penalty:-1 },
  { lv:9,  cost:7000, rate:0.4,  penalty:-2 },
  { lv:10, cost:12000,rate:0.25, penalty:-5 },
];

// 袖珍罐
export const JARS = [
  { id:'common_jar', name:'普通袖珍罐', price:500, tiers:['common','fine'], icon:'🏺', desc:'普通~精良装备' },
  { id:'rare_jar',   name:'稀有袖珍罐', price:2000,tiers:['fine','rare'], icon:'🏺✨', desc:'精良~稀有装备' },
  { id:'epic_jar',   name:'史诗袖珍罐', price:8000,tiers:['rare','unique','epic'], icon:'🏺💎', desc:'稀有~史诗装备' },
];
